import React, { Component, Fragment } from 'react';
import CheckBox from '~/js/components/CheckBox';

class CountryRadios extends Component {
  state = {
    countryCodes: Object.keys(this.props.resorts),
    countryData: Object.values(this.props.resorts),
  };

  resortSum = () => {
    return this.state.countryData.reduce((total, currentValue) => {
      return total + currentValue;
    }, 0);
  };

  render() {
    const { countryCodes, countryData } = this.state;
    const { resorts, disabled } = this.props;
    const countryCodeConverter = {
      AG: {
        name: 'Antigua'
      },
      CW:{
          name: 'Curacao'
      },
      BS: {
        name: 'Bahamas'
      },
      BB: {
        name: 'Barbados'
      },
      GD: {
        name: 'Grenada'
      },
      JM: {
        name: 'Jamaica'
      },
      LC: {
        name: 'St. Lucia'
      },
      VC: {
        name: 'Saint Vincent and the Grenadines'
      },
    };
    return (
      <Fragment>
        <h3 className="list-title">By Resort Location</h3>
        <ul className="resort-list">
          {countryCodes.map((item, index) => {
            return (
              <li key={item} className={disabled.includes(item) ? ' disabled' : ''}>
                <CheckBox
                  label={`${countryCodeConverter[item].name} (${countryData[index]} ${
                    countryData[index] > 1 ? 'Resorts' : 'Resort'
                  })`}
                  classNames="checkbox"
                  onChange={(e) => this.props.countryChange(e, item, 'country')}
                  isChecked={this.props.activeCountries.includes(item) && !disabled.includes(item)}
                  isDisabled={disabled.includes(item)}
                />
              </li>
            );
          })}
        </ul>
      </Fragment>
    );
  }
}

export default CountryRadios;